import React, { ReactNode } from 'react';
import { Image as ImageType } from '../../../../types/api/ImageType';

type PortraitProfileImage = {
  image: ImageType;
  children: ReactNode;
};

/**
 * We offer a special look for profile images in portrait mode.
 * They appear in a landscape container.
 * Does not work for ProfileImageSmall.
 */
export function PortraitProfileImage({ image, children }: PortraitProfileImage) {
  if (image.imageType === 'profileImage' && image.orientation === 'portrait') {
    return <div className="image__profile-portrait">{children}</div>;
  }
  return children;
}
